import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { BlockingWaitFacade } from '../../../Facades/blocking-wait.facade';
import { BLOCKING_WAIT } from '../Consts/blocking-wait.const';

export const blockingWaitInterceptor: HttpInterceptorFn = (req, next) => {
  const blockingWait = inject(BlockingWaitFacade);

  if (!req.context.get(BLOCKING_WAIT)) {
    return next(req);
  }

  blockingWait.begin();

  return next(req).pipe(finalize(() => blockingWait.end()));
};
